export default "__VITE_ASSET__DhNeJhSp__"